import { ContractContext } from '@context/Contract';
import { useContext } from 'react';

export default function useContractContext() {
  return useContext(ContractContext);
}
